<template>
  <Modal
    @closeModal="closeModal"
    v-show="showModal"
    :isSaving="isLoading"
    title="Delete Confirmation"
    :okFunction="deleteApp"
  >
    <template v-slot:body>
      <div class="delete-description">Are you sure you want to delete this folder?</div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { apiDeleteFolder } from '@/api/content';

  export default {
    name: 'FolderDeleteModal',

    components: { Modal },

    props: {
      folder: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        showModal: false,
        isLoading: false,
      };
    },

    mounted() {
      this.showModal = true;
    },

    methods: {
      async deleteApp() {
        this.isLoading = true;

        try {
          await apiDeleteFolder(this.folder.id);

          this.$emit('onDelete');
          this.$toasted.global.general_success({ message: 'Folder successfully deleted' });
          this.closeModal(true);
        } catch (error) {
          this.$toasted.global.general_error({
            message: error.response?.data?.message || 'Failed to delete the folder',
          });
        }
        this.isLoading = false;
      },

      closeModal() {
        this.showModal = false;
        this.$emit('closeModal');
      },
    },
  };
</script>
